import { render, staticRenderFns } from "./Subtitler.vue?vue&type=template&id=bbd55430&scoped=true&"
import script from "./Subtitler.vue?vue&type=script&lang=js&"
export * from "./Subtitler.vue?vue&type=script&lang=js&"
import style0 from "./Subtitler.vue?vue&type=style&index=0&id=bbd55430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd55430",
  null
  
)

export default component.exports